import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./index.scss";

export const TimerInfo = ({
  message = "Você será redirecionado em",
  timer = 120,
  redirectTo = "/login",
}: {
  message?: string;
  timer?: number;
  redirectTo?: string;
}): JSX.Element => {
  const [time, setTime] = useState(timer);
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      if (time > 0) setTime((oldTime) => oldTime - 1);
      if (!time) history.push(redirectTo);
    }, 1000);
  }, [time]);

  const hours = String(Math.floor(time / 60))?.padStart(2, "0");
  const minutes = String(time % 60)?.padStart(2, "0");

  return (
    <>
      <div className="timer-info bg-blue-100 text-primary font-familyPoppins text-sm px-2 py-1 rounded-xl">
        <p>
          {message}
          <span className="text-base font-semibold">
            {hours}:{minutes}
          </span>
        </p>
      </div>
    </>
  );
};
